import React from 'react';
import PropTypes from 'prop-types';

const PLACEHOLDER = 'YYYY - MM';
const SELECT_DATE_TYPE = { INC: 'INC', DEC: 'DEC' };

export default class MonthPicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
    };

    this.months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
  }

  _toggle = () => {
    const { expanded } = this.state;

    if (!expanded) {
      document.addEventListener('click', this._toggle);
      this.setState({ expanded: true });
    } else {
      document.removeEventListener('click', this._toggle);
      this.setState({ expanded: false });
    }
  };

  _handleYearSelect = selectType => event => {
    const { chosenYear, handleSelectYear } = this.props;

    event.stopPropagation();
    if (event.nativeEvent) event.nativeEvent.stopImmediatePropagation();

    switch (selectType) {
      case SELECT_DATE_TYPE.INC:
        handleSelectYear(+chosenYear + 1);
        break;
      case SELECT_DATE_TYPE.DEC:
        handleSelectYear(+chosenYear - 1);
        break;
      default:
        break;
    }
  };

  handleMonthSelect = month => event => {
    const { handleSelectMonth } = this.props;

    event.stopPropagation();
    if (event.nativeEvent) event.nativeEvent.stopImmediatePropagation();
    handleSelectMonth(month);
    this._toggle();
  };

  getMonths = () => {
    const { chosenMonth } = this.props;
    const months = [];

    for (let i = 1, l = 13; i < l; i++) {
      months.push(
        <div key={i} className={`day ${i === +chosenMonth ? 'active' : ''}`} onClick={this.handleMonthSelect(i)}>
          {this.months[i - 1]}
        </div>
      );
    }

    return months;
  };

  render() {
    const { expanded } = this.state;
    const { error, label, mainWrapperClassName, chosenYear, chosenMonth } = this.props;

    return (
      <div className={`date-picker-wrapper date-picker-wrapper_noInput} ${mainWrapperClassName}`}>
        {label && <label>{label}</label>}
        <div className='date-picker-input-wrapper'>
          <div className={`month-picker_input ${error ? 'error' : ''}`}>
            {chosenYear && chosenMonth ? `${chosenYear} - ${chosenMonth}` : PLACEHOLDER}
          </div>
          {typeof error === 'string' && <div className='error-text'>{error}</div>}
        </div>
        <div className='date-picker-open-button' onClick={this._toggle} />
        {expanded ? (
          <div className='month-picker_dropdown'>
            <div className='year-choose-section'>
              <div className='arrow decrease' onClick={this._handleYearSelect(SELECT_DATE_TYPE.DEC)}>
                <div />
              </div>
              <div className='text-holder'>{chosenYear}</div>
              <div className='arrow increase' onClick={this._handleYearSelect(SELECT_DATE_TYPE.INC)}>
                <div />
              </div>
            </div>
            <div className='day-choose-section'>{this.getMonths()}</div>
          </div>
        ) : null}
      </div>
    );
  }
}

MonthPicker.propTypes = {
  chosenMonth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  chosenYear: PropTypes.number,
  handleSelectMonth: PropTypes.func,
  handleSelectYear: PropTypes.func,
  label: PropTypes.string,
  error: PropTypes.string,
  mainWrapperClassName: PropTypes.string,
};

MonthPicker.defaultProps = {
  chosenMonth: 0,
  chosenYear: 0,
  handleSelectYear: () => {},
  handleSelectMonth: () => {},
  label: '',
  error: '',
  mainWrapperClassName: '',
};



// WEBPACK FOOTER //
// ./src/app/Components/MonthPicker.jsx